<template>
  <div class="new-pc-header-cover">
    <div class="info-desc">
      <div class="lt">
        <img v-lazy="gameIcon" v-if="gameIcon" />
      </div>
      <div class="rt">
        <h3 :style="mFontColor">{{ titleInfo.gameName }}</h3>
        <div class="auth-info" :style="pcTagBckColor">
          <MBIcon :size="14" name="icon-shield" :color="pcTagTextColor.color" />
          <span class="info" :style="pcTagTextColor">{{
            $t('publicDetails.pc_banner_title')
          }}</span>
        </div>
        <client-only>
          <VClamp :style="mFontColor" class="desc" autoresize :max-lines="1">
            {{ titleInfo.gameDesc }}
            <template #after="{ toggle, expanded, clamped }">
              <button
                v-show="expanded || clamped"
                :style="{
                  '--borderColor': mFontColor.color,
                }"
                :class="['drop-down-icon', expanded ? 'up' : '']"
                @click="toggle"
              ></button>
            </template>
          </VClamp>
        </client-only>
      </div>
      <!--分辨率小于>=900显示banner -->
      <slot> </slot>
    </div>
    <div class="full-decrement" v-if="isRenderTipLayout">
      <!-- 未登录 -->
      <div class="not-logged" v-if="isRenderTips" :style="moduleBackColor">
        <div class="lt">
          <img v-if="couponImg" v-lazy="couponImg" />
          <p>{{ $t('publicDetails.pc_login_success_title') }}</p>
        </div>
        <div class="rt">
          <div class="login-button" @click="handleLogin">
            {{ $t('publicDetails.pc_login_btn') }}
          </div>
        </div>
      </div>
      <!--
          已登录\就能显示
      -->
      <div class="login-succeed" v-if="isLogin" :style="moduleBackColor">
        <img v-if="pcCouponIcon" v-lazy="pcCouponIcon" />
        <p :style="mFontColor">{{ $t('publicDetails.pc_order_prompt') }}</p>
      </div>
    </div>
  </div>
</template>
<script>
  import MBIcon from '@/components/MBIcon'
  import isEmpty from 'lodash/isEmpty'
  import VClamp from 'vue-clamp'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
  import { getTip } from '@/api/activity/coupon'
  export default {
    name: 'new-pc-header-cover',
    mixins: [styleConfiguration],
    components: {
      MBIcon,
      VClamp,
    },
    data() {
      return {
        couponImg: '', // 渲染的图片
        isTip: false, // TIP 接口数据为空的状态
        titleData: {},
      }
    },
    computed: {
      ...mapState([
        'userInfo',
        'gameName',
        'region',
        'source',
        'isGetapps',
        'hotfixIsFetchSuccess',
        'loginFromCouponPop',
      ]),
      ...mapState('detail', ['detailBasicConfig']),
      ...mapGetters(['isLogin', 'isShiningNikki']),
      // 邮箱模式具体是显示了邮箱输入框，则不显示提示语
      isRenderTipLayout() {
        return this.uidModuleType !== 6
      },
      // 未登录切无优惠券时、优惠券栏消失
      isRenderTips() {
        return !this.isLogin && this.isTip
      },
      titleInfo() {
        const _displayName = this.$t(`publicDetails.displayName`, {
          gameName: this.gameName,
        })
        const gameName = this.titleData.mainTitle || _displayName

        const _game_desc = this.$t(`publicDetails.game_desc`)
        const gameDesc = this.titleData.subTitle || _game_desc

        return {
          gameName,
          gameDesc,
        }
      },
    },
    watch: {
      detailBasicConfig: {
        handler(newVal = {}) {
          const { gameShowDetail = {} } = newVal
          if (isEmpty(gameShowDetail)) return
          this.titleData = gameShowDetail
        },
        deep: true,
        immediate: true,
      },
      loginFromCouponPop: {
        handler() {
          this['detail/setCouponUplogin'](false)
          // 更新KB的值
          this.getWalletBalance()
        },
        deep: true,
      },
    },
    created() {
      this.getTipData()
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
      ...mapActions(['getWalletBalance']),
      ...mapMutations(['detail/setCouponUplogin']),
      handleLogin() {
        this['detail/setCouponUplogin'](true)
      },
      async getTipData() {
        try {
          // 需要确定数据类型
          const result = await getTip(this.region, this.gameName, this.source)
          if (Array.isArray(result) && result.length === 0) return

          if (typeof result === 'object') {
            const { activity = {} } = result
            const { extraInfo = '' } = activity
            this.isTip = true

            if (extraInfo) {
              const _extraInfo = JSON.parse(extraInfo)
              this.couponImg = _extraInfo.notLoginTipPic || ''
            }
          }
        } catch (error) {
          window.console.warn('%c[_getTipData_]方法报错', 'color:#0f0', error)
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }

  @media (min-width: 768px) and (max-width: 1280px) {
    @import './index_pc.scss';
  }
  @media (max-width: 900px) {
    @import './900.scss';
  }
</style>
